import {
  Component,
  Injector,
  OnInit,
  ViewEncapsulation,
  NgZone,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  FormsServiceProxy,
  NotificationServiceProxy,
  UserNotification,
} from '@shared/service-proxies/service-proxies';
import {
  IFormattedUserNotification,
  UserNotificationHelper,
} from './UserNotificationHelper';

import { UrlHelper } from '@shared/helpers/UrlHelper';
import { MessageService } from 'abp-ng2-module';

@Component({
  templateUrl: './header-notifications.component.html',
  selector: 'header-notifications',
  styleUrls:["./header-notifications.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderNotificationsComponent
  extends AppComponentBase
  implements OnInit {
  notifications: IFormattedUserNotification[] = [];
  unreadNotificationCount = 0;
  @Input() isDropup = false;
  @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean btn-lg mr-1';
 @Output() approveButtonClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private _notificationService: NotificationServiceProxy,
    private _userNotificationHelper: UserNotificationHelper,
    private _formServiceProxy: FormsServiceProxy,
    private _messageService: MessageService,
    public _zone: NgZone
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadNotifications();
    this.registerToEvents();
  }

  loadNotifications(): void {
    if (UrlHelper.isInstallUrl(location.href)) {
      return;
    }

    this._notificationService
      .getUserNotifications(undefined, undefined, undefined, 3, 0)
      .subscribe((result) => {
        this.unreadNotificationCount = result.unreadCount;
        this.notifications = [];
        result.items.forEach( (item: UserNotification) => {
          if(item.notification.notificationName!=='App.CurrentProjectCacheEmpty'){
            this.notifications.push(
              this._userNotificationHelper.format(<any>item)
            );
          }
        });
      });
  }

  registerToEvents() {
    let self = this;

    function onNotificationReceived(userNotification) {
      self._userNotificationHelper.show(userNotification);
      self.loadNotifications();
    }

    abp.event.on('abp.notifications.received', (userNotification) => {
      self._zone.run(() => {
        onNotificationReceived(userNotification);
      });
    });

    function onNotificationsRefresh() {
      self.loadNotifications();
    }

    abp.event.on('app.notifications.refresh', () => {
      self._zone.run(() => {
        onNotificationsRefresh();
      });
    });

    function onNotificationsRead(userNotificationId) {
      for (let i = 0; i < self.notifications.length; i++) {
        if (self.notifications[i].userNotificationId === userNotificationId) {
          self.notifications[i].state = 'READ';
          self.notifications[i].isUnread = false;
        }
      }

      self.unreadNotificationCount -= 1;
    }

    abp.event.on('app.notifications.read', (userNotificationId) => {
      self._zone.run(() => {
        onNotificationsRead(userNotificationId);
      });
    });
  }

  setAllNotificationsAsRead(): void {
    this._userNotificationHelper.setAllAsRead();
  }

  openNotificationSettingsModal(): void {
    this._userNotificationHelper.openSettingsModal();
  }

  setNotificationAsRead(userNotification: IFormattedUserNotification): void {
    if (userNotification.state !== 'READ') {
      this._userNotificationHelper.setAsRead(
        userNotification.userNotificationId
      );
    }
  }

  handleApproval(userNotification: IFormattedUserNotification): void {
    var parentTemplateId = userNotification.data.properties.parentDefinitionId;
    this._formServiceProxy.getTenantFormDefinitionByParentTemplateId(parentTemplateId).subscribe(x=> {
    this._formServiceProxy.
    updateTenantFormDefinition(parentTemplateId, x.id).subscribe((x) => {
      this._messageService.success('You have successfully updated form.');})
    })
        
  }

  gotoUrl(url): void {
    if (url) {
      location.href = url;
    }
  }
}
